/**
 * Whether a civilisation can see a resource (ADR-0063). Strategic resources stay hidden —
 * no icon, no yield, no use — until their owner learns the technology that reveals them.
 *
 * A leaf module, so the yield code and the renderer can both ask without importing the
 * network code.
 */

import type { Content } from '../../../content/schema/index.js';
import { hasTech } from '../research/knowledge.js';
import type { Civ } from '../state/types.js';

export function resourceKnown(content: Content, civ: Civ | undefined, resource: number): boolean {
  if (resource === 0) return false;
  const def = content.resources.get(resource);
  return def.revealedId < 0 || (civ !== undefined && hasTech(civ, def.revealedId));
}

/** Whether any unit needs this resource — one nobody needs is not worth trading. */
export function resourceUsed(content: Content, resource: number): boolean {
  return content.units.all.some((u) => u.resourceIds.includes(resource));
}

/** The names of the resources in a mask, in content order. */
export function resourceNames(content: Content, mask: number): string[] {
  return content.resources.all.filter((r) => (mask & (1 << r.id)) !== 0).map((r) => r.name);
}
